<template>
  <div class="FieldLaptopImage">
    <LaptopImage
      v-if="imageFileId"
      :laptop="{ imageFileId }">
      <Btn @click="isImageDropVisible = true">
        {{ $t('change') }}
      </Btn>
    </LaptopImage>
    <ImageDrop
      v-if="isImageDropVisible || !imageFileId"
      :id="`laptop-${laptopId}`"
      type="LAPTOP_IMAGE"
      @update:file="$up('imageFileId', $event.id)" />
  </div>
</template>

<script>
import ImageDrop from '@components/fields/ImageDrop'
import LaptopImage from '@components/LaptopImage'

export default {
  components: {
    ImageDrop,
    LaptopImage,
  },
  props: {
    imageFileId: { type: Number, default: null },
    laptopId: { type: Number, required: true },
  },
  data() {
    return {
      isImageDropVisible: false,
    }
  },
}
</script>

<style lang="scss">
.FieldLaptopImage {
}
</style>

<i18n>
{
  "en": {
    "change": "Change"
  }
}
</i18n>
